export default class DtoTerritoryActivitie {
    constructor(obj) {
        this.section = obj.section
        this.activityCode = obj.activityCode
        this.activity = obj.activity
        this.numberInstitutions = obj.numberInstitutions
        this.headers = ['section', 'activityCode', 'activity', 'numberInstitutions']
    }
}